import React from 'react';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';

const ACTION_COLORS: Record<string, string> = {
    fold: '#F52740',
    call: '#CC976D',
    bet: '#3DE361',
    raise: '#3DE361',
    allin: '#E5C353',
    win: '#E5C353',
    check: '#777A84',
};

const DEFAULT_BACKGROUND = '#3E414D';

const ActionBadge = styled(Box, {
    shouldForwardProp: (prop) => prop !== '$isFolded' && prop !== '$backgroundColor'
})<{ $isFolded?: boolean; $backgroundColor?: string }>(({ theme, $isFolded, $backgroundColor }) => ({
    position: 'absolute',
    top: 0,
    left: "50%",
    transform: 'translateX(-50%)',
    color: $backgroundColor == DEFAULT_BACKGROUND ? 'white' : '#3D3B40',
    backgroundColor: $backgroundColor ?? DEFAULT_BACKGROUND,
    fontSize: '10px',
    padding: '2px 8px',
    borderRadius: '30px',
    fontWeight: 700,
    textTransform: 'capitalize',
    fontFamily: '"Inter", serif',
    whiteSpace: 'nowrap',
    overflow: 'visible',
    zIndex: 30,
    opacity: 1,
    pointerEvents: 'none',
}));

interface PlayerActionBadgeProps {
    action: string;
    amount: number;
    position: React.CSSProperties;
    isFolded?: boolean;
    currencyType?: string;
    currency?: string;
}

const PlayerActionBadge: React.FC<PlayerActionBadgeProps> = ({ 
    action, 
    amount, 
    position, 
    isFolded,
    currencyType = 'fiat',
    currency = 'USD'
}) => {
    if (!action) return null;

    const getCurrencySymbol = () => {
        return currencyType === 'crypto' ? currency : currencyType === 'tournament_chips' ? '' : '$';
    };

    const backgroundColor = ACTION_COLORS[action.toLowerCase().replace(/[\s-]/g, '')] ?? DEFAULT_BACKGROUND;

    return (
        <ActionBadge 
            style={position} 
            $isFolded={isFolded}
            $backgroundColor={backgroundColor}
        >
            {`${action.charAt(0).toUpperCase() + action.slice(1)} ${amount > 0 ? `${getCurrencySymbol()}${amount}` : ''}`}
        </ActionBadge>
    );
};

export default React.memo(PlayerActionBadge);
